import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REPLACE_CUISINE_TYPE_MUTATION } from '../graphql/mutations'
import { REPLACE_CUISINE_TYPE } from '../redux/action-types'

const useReplaceCuisineTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.cuisineTypes.cuisineTypes,
  )

  const mutate = useCallback(
    async ({ idToReplace, replacementId }) => {
      await apolloService.mutate(
        REPLACE_CUISINE_TYPE_MUTATION,
        {
          idToReplace,
          replacementId,
        },
        dispatch,
        REPLACE_CUISINE_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useReplaceCuisineTypeMutation
